import { useMemo } from 'react';
import { useMapContext } from '~/map/map/mapContext';
import { MapObjectManager } from './mapObjectManager';

export const useMapObjectManager = () => {
  const { map, webglLayers } = useMapContext();
  return useMemo(() => new MapObjectManager(map, webglLayers), [map, webglLayers]);
};
